import { Navigate } from 'react-router-dom';

import { DashboardRoute } from './dashboard-route';
import { AccessDeniedPanel } from '../components/layout/AccessDeniedPanel';
import { useAccount } from '../contexts/AccountContext';
import { firstAccessibleRoute } from '../domain/access';

/**
 * `/` = tableau de bord (domaine Courses). Un profil sans ce domaine — par
 * exemple `Extranet_Facturation` — atterrit sur sa première page accessible.
 */
export const HomeRoute = () => {
  const { can, domains } = useAccount();
  if (can('trips')) return <DashboardRoute />;

  const home = firstAccessibleRoute(domains);
  if (!home || home === '/') {
    return <AccessDeniedPanel description="Aucune page n'est accessible avec vos droits actuels." />;
  }
  return <Navigate to={home} replace />;
};
